import React from 'react';
import { Grid } from '@mui/material';
import { useStyles } from './stats.styles';
import { Color } from '../../../types/app/chart.types';

interface Props {
  items: StatsLabelTopItem[];
  columnsCount: 1 | 2 | 3 | 4 | 5 | 6;
  direction: 'column' | 'row';
  marginTop?: 1 | 2 | 3;
  isCompact?: boolean;
}

export interface StatsLabelTopItem {
  id: number;
  label: string;
  value: string;
  textColor?: Color;
  colOffset?: number;
  isCompact?: boolean;
  fontSizeVal?: string | number;
}

export function Stats({ items, columnsCount, direction, marginTop, isCompact }: Props) {
  const classes = useStyles();
  const col = 12 / columnsCount;
  const isRow = direction === 'row';

  return (
    <Grid
      container
      style={{
        marginTop: isCompact ? 0 : `${marginTop}rem`,
      }}
    >
      {items.map((item, i) => {
        return (
          <Grid key={i} item xs={12} md={item.colOffset ? item.colOffset + col : col}>
            <Grid
              style={{
                display: isRow ? 'flex' : 'column',
              }}
            >
              <Grid className={isRow ? classes.labelBoldInlineLeft : classes.labelBold}>
                {item.label}
              </Grid>
              <Grid
                className={isRow ? classes.valueInlineRight : classes.value}
                style={{
                  color:
                    'rgb(' +
                    item?.textColor?.r +
                    ',' +
                    item?.textColor?.g +
                    ',' +
                    item?.textColor?.b +
                    ')',
                  fontSize: item.fontSizeVal ? item.fontSizeVal : undefined,
                }}
              >
                {item.value}
              </Grid>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
}
